import { LockIcon } from "@phosphor-icons/react/Lock";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { T } from "@freightsimple/ui-core/Typography/T";
import type { ReactNode } from "react";

interface StoreCreditCardButtonProps {
  onClick: () => void;
  storingInProgress: boolean;
  storingSuccess: boolean;
  storingFailure: boolean;
  failureMessage: ReactNode;
}

function CreditCardsStoreButton(props: StoreCreditCardButtonProps) {
  return (
    <Row gap={2} align="center">
      <Button
        primary
        // The one action on the payment step, so it is sized like the other
        // standalone CTAs. Cargo asked for `size="large"` here and the ui-core
        // migration dropped it, which quietly shrank it to a default button.
        size="large"
        icon={LockIcon}
        loading={props.storingInProgress}
        onClick={props.onClick}
        data-testid="store-credit-card-button"
      >
        Securely Store Credit Card
      </Button>
      {!props.storingInProgress && props.storingFailure && (
        <T size="sm" color="red">
          {props.failureMessage}
        </T>
      )}
    </Row>
  );
}
export default CreditCardsStoreButton;
